import React from 'react'
import { Trans, useTranslation, withI18nContext } from '@mc/i18n'
import { TableHeader, useTiersInfo } from '@mc/plans-ui'
import { BOGO_I18N_NAMESPACE, i18nInstance } from '../../../i18n'

const BogoMatrixHeaderComp = () => {
  const { t } = useTranslation(BOGO_I18N_NAMESPACE)
  const { individual, duo, family } = useTiersInfo()

  return (
    <>
      <TableHeader.Titles>
        <TableHeader.IndividualTitle>
          <Trans
            i18nKey='plans.planName.title'
            ns={BOGO_I18N_NAMESPACE}
            values={{ plan: individual.displayName }}
          >
            <br />
          </Trans>
        </TableHeader.IndividualTitle>
        <TableHeader.DuoTitle>
          <Trans
            i18nKey='plans.planName.title'
            ns={BOGO_I18N_NAMESPACE}
            values={{ plan: duo.displayName }}
          >
            <br />
          </Trans>
        </TableHeader.DuoTitle>
        <TableHeader.FamilyTitle>
          <Trans
            i18nKey='plans.planName.title'
            ns={BOGO_I18N_NAMESPACE}
            values={{ plan: family.displayName }}
          >
            <br />
          </Trans>
        </TableHeader.FamilyTitle>
      </TableHeader.Titles>

      <TableHeader.Actions className='bogoActions'>
        <TableHeader.IndividualAction
          description={
            <Trans
              ns={BOGO_I18N_NAMESPACE}
              i18nKey='plans.header.one.devicesInfo'
            >
              <br />
            </Trans>
          }
          label={t('plans.header.cta.label', {
            plan: individual.displayName,
          })}
          selectedLabel={t('plans.header.cta.selected')}
          unselectedLabel={t('plans.header.cta.select')}
        />
        <TableHeader.DuoAction
          description={
            <Trans
              ns={BOGO_I18N_NAMESPACE}
              i18nKey='plans.header.two.devicesInfo'
            >
              <br />
            </Trans>
          }
          label={t('plans.header.cta.label', {
            plan: duo.displayName,
          })}
          selectedLabel={t('plans.header.cta.selected')}
          unselectedLabel={t('plans.header.cta.select')}
        />
        <TableHeader.FamilyAction
          description={
            <Trans
              ns={BOGO_I18N_NAMESPACE}
              i18nKey='plans.header.three.devicesInfo'
            >
              <br />
            </Trans>
          }
          label={t('plans.header.cta.label', {
            plan: family.displayName,
          })}
          selectedLabel={t('plans.header.cta.selected')}
          unselectedLabel={t('plans.header.cta.select')}
          badge={t('plans.header.bestValue')}
        />
      </TableHeader.Actions>
    </>
  )
}

export const BogoMatrixHeader =
  withI18nContext(i18nInstance)(BogoMatrixHeaderComp)
